export type MarkdownFormat = 'bold' | 'italic' | 'list' | 'link';

export interface MarkdownEdit {
  value: string;
  selectionStart: number;
  selectionEnd: number;
}

/**
 * Applique un bouton de la barre d'outils à la sélection d'une zone de saisie Markdown, et dit quoi
 * sélectionner ensuite : le texte mis en forme, ou l'adresse d'un lien à compléter.
 */
export function applyMarkdown(
  value: string,
  start: number,
  end: number,
  format: MarkdownFormat,
): MarkdownEdit {
  const before = value.slice(0, start);
  const selected = value.slice(start, end);
  const after = value.slice(end);
  const edit = (inserted: string, from: number, to: number): MarkdownEdit => ({
    value: before + inserted + after,
    selectionStart: start + from,
    selectionEnd: start + to,
  });

  switch (format) {
    case 'bold': {
      const text = selected || 'texte en gras';
      return edit(`**${text}**`, 2, 2 + text.length);
    }
    case 'italic': {
      const text = selected || 'texte en italique';
      return edit(`*${text}*`, 1, 1 + text.length);
    }
    case 'list': {
      const list = (selected || 'élément')
        .split('\n')
        .map((line) => `- ${line}`)
        .join('\n');
      return edit(list, 0, list.length);
    }
    case 'link': {
      const text = selected || 'texte du lien';
      const url = 'https://';
      return edit(`[${text}](${url})`, text.length + 3, text.length + 3 + url.length);
    }
  }
}
